import { render, staticRenderFns } from "./VaIcon.demo.vue?vue&type=template&id=08dfe38d&"
import script from "./VaIcon.demo.vue?vue&type=script&lang=js&"
export * from "./VaIcon.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports